"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverseStr = void 0;
const reverseStr = (str) => str.split('').reverse().join('');
exports.reverseStr = reverseStr;
//# sourceMappingURL=reverseString.js.map